
import { Vue, Component } from 'vue-property-decorator'
import { TeaConfig } from '@/const/dashboard'
import HeaderNav from '@/components/header-nav.vue'

@Component({
  name: 'Promotional',
  components: {
    HeaderNav,
  }
})

export default class Promotional extends Vue {
  TeaConfig = TeaConfig;

  goBack(): void {
    this.$router.back()
  }

  getHeaderNavTitle(): string {
    switch (this.$route.name) {
      case "promotional-best-practice":
        return this.$t('module_promotional_best_practice_top_title')

      case "promotional-pixel":
      case "promotional-creative":
      default:
        return ""
    }

  }
}

